export const PAYROLL_INSTRUCTIONS_FINISHED = 'ui.payroll_instructions.finished';

export const PAYROLL_INSTRUCTIONS_SET_UP_LATER =
    'ui.payroll_instructions.set_up_later';

export const PINWHEEL_EVENT_BANKING_INPUT_CONTINUE =
    'BankingConfirmation Continue';
